import BreadCrumbs from "../../../components/BreadCrumb.vue";
import tree from "../../../components/trees.vue"

export default {
    name: "organizaManagement",
    components: { BreadCrumbs, tree },
    data() {
        return {
            isSearch: true,
            Details: {},
            id: ''
        }
    },
    mounted() {
        
    },
    methods: {
        getDetails() {
            let param = {
                id: this.id
            }
            this.$store.dispatch('tree/GET_QUERYTREEONE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.Details = {
                            upid : res.data.data.upid,
                            level : res.data.data.level,
                            updateTime : res.data.data.updateTime,
                            createTime : res.data.data.createTime,
                            lastUser : res.data.data.lastUser,
                            childrenNum : res.data.data.childrenNum
                        }
                    }
                }
            })
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getDetails()
         },
        nodeClick(val) {
            this.id = val.label
            this.getDetails()
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}


